// * Display build information in console
// * This helps verify which deployment is currently running

export const logBuildInfo = () => {
  const buildId = import.meta.env.VITE_BUILD_TIMESTAMP || "local-dev";

  // Helper to pad strings
  const pad = (str: string, length: number) => {
    return (str || "").substring(0, length).padEnd(length, " ");
  };

  // Create a beautiful console message
  const styles = {
    title: "color:#1f8385; font-size: 16px; font-weight: bold;",
    label: "color: #7B92A9; font-weight: bold;",
    value: "color:#53cbff;",
    separator: "color: #DBE8F5;"
  };

  console.log("%c╔═══════════════════════════════════════════╗", styles.separator);
  console.log("%c║                                           ║", styles.separator);
  console.log("%c║  ALTIUS BUILD INFORMATION   ║", styles.title);
  console.log("%c║                                           ║", styles.separator);
  console.log("%c╠═══════════════════════════════════════════╣", styles.separator);

  console.log(`%c║  Build ID: ${pad(buildId, 29)}  ║`, styles.value);

  const env = import.meta.env.MODE || "development";
  console.log(`%c║  Environment: ${pad(env, 26)}  ║`, styles.value);

  console.log("%c╚═══════════════════════════════════════════╝", styles.separator);
  console.log("");
};
